


























































































import {
    defineComponent,
    PropType,
    computed,
} from '@vue/composition-api';

import { BreadcrumbItem } from './types';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'SdsBreadcrumbItem',
    props: {
        item: {
            type: Object as PropType<BreadcrumbItem>,
            required: true,
        },
        isInDropdown: {
            type: Boolean,
            default: false,
        },
        isFirstItem: {
            type: Boolean,
            default: false,
        },
        isLastItemInteractive: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { slots }) {
        const isCurrentUrl = computed(() => {
            const { to, url } = props.item;
            const lastPath = window.location.pathname;

            return to === lastPath || url === lastPath ? 'page' : undefined;
        });

        const hasSlot = (name: string) => !!slots[name];

        const hasAction = computed(() => props.item.action || hasSlot('action'));

        const hasIcon = computed(() => props.item.icon || hasSlot('icon'));

        // No need to render breadcrumb at all if there's no label provided or default slot is empty
        const hasLabel = computed(() => props.item.label || hasSlot('default'));

        return {
            isCurrentUrl,
            hasAction,
            hasIcon,
            hasLabel,
        };
    },
    components: {
        SdsIcon,
    },
});
